import TreatmentStepHelper from "../modules/step-helper";
import PlanSimpleModifierService from "./plan-simple-modifier-service";

// Sort of teeth on upper jaw.
const sortArrayUpperJaw = [
    14, 15, 16, 17,
    13, 12, 11,
    21, 22, 23,
    24, 25, 26, 27,
];

// Sort of teeth on lower jaw.
const sortArrayLowerJaw = [
    44, 45, 46, 47,
    43, 42, 41,
    31, 32, 33,
    34, 35, 36, 37,
];

export default {
    lastOrder: 0,
    affectedRegions: [],
    tpl: null,

    /**
     * @param {number} region
     * @return {number[]}
     */
    getTreatableTeeth(region) {
        const toothIds = Helper.getRegionTeethIds(region);
        let available = toothIds.filter((tId) => !app.$store.state.simplePlan.treatedToothNumbers.includes(tId));

        // Sort available teeth order, if necessary.
        if (available.length) {
            // Check tooth number and select jaw.
            const sortableArray = sortArrayUpperJaw.includes(available[0]) ? sortArrayUpperJaw : sortArrayLowerJaw;

            // Sort available teeth by fixed order.
            available = available.sort((a, b) => sortableArray.indexOf(a) - sortableArray.indexOf(b));
        }

        return available.map(Number);
    },

    getTreatmentOptions(stateId, language, currency) {
        if (typeof currency === "undefined") currency = window.app.$store.state.currency;
        if (typeof language === "undefined") language = window.app.$store.state.language;
        stateId = parseInt(stateId);

        if (stateId === 9) stateId = 15;

        const options = [];
        Object.values(window.app.$store.state.dentalStates).forEach((state) => {
            if (parseInt(state.parent_id) !== stateId) return;
            if (parseInt(state.id) === stateId) return;
            if (parseInt(state.status) < 1) return;
            if (parseInt(state.id) < 1000) return;
            options.push(state.id);
        });
        return options;
    },

    getAffectedRegions(tpl, selectedRegion) {
        this.affectedRegions = [];
        if (typeof(tpl.full_jaw)!=="undefined" && parseInt(tpl.full_jaw) === 1) {
            if (selectedRegion<3) this.affectedRegions = [0, 1, 2];
            else this.affectedRegions = [3, 4, 5];
        } else {
            this.affectedRegions = [selectedRegion];
        }
        return this.affectedRegions;
    },

    getStepsForRegion(tpl, region = 0) {
        if (typeof(tpl.steps)==="undefined") return [];
        const steps = [];
        tpl.steps.forEach((step) => {
            const finalStep = JSON.parse(JSON.stringify(step));
            if (typeof step.tooth_id === "undefined") {
                if (parseInt(tpl.full_jaw) === 1) finalStep.tooth_id = region>2 ? finalStep.tooth_id_lower : finalStep.tooth_id_upper;
                else finalStep.tooth_id = (region === 2 || region === 5) ? finalStep.tooth_id_front : finalStep.tooth_id_back;
            }
            steps.push(finalStep);
        });
        return steps;
    },

    getStatusForRegion(tpl, region = 0) {
        if (parseInt(tpl.full_jaw) === 1) {
            if (typeof(tpl.status)==="undefined") return [];
            if (region>2 && typeof(tpl.status_lower)!=="undefined") return tpl.status_lower;
            else return tpl.status;
        } else {
            if (region === 2 || region === 5) {
                if (typeof(tpl.status_front)==="undefined") return [];
                return tpl.status_front;
            } else {
                if (typeof(tpl.status_back)==="undefined") return [];
                return tpl.status_back;
            }
        }
    },

    getStatus(tpl, region) {
        // Remove all status from the affected regions
        // this.cleanupStatus();
        const status = [];
        const tplStatus = this.getStatusForRegion(tpl, region);

        for (const toothId in tplStatus) {
            if (tplStatus.hasOwnProperty(toothId)) {
                status.push({
                    tooth_id: this.convertToothForArea(toothId, region, tpl.full_jaw),
                    state_id: parseInt(tplStatus[toothId]),
                    state_pid: parseInt(tplStatus[toothId]),
                });
            }
        }

        return status;
    },

    getBaseTemplatePositions(tpl, region) {
        if (tpl.full_jaw) return [];
        const regionToothIds = Helper.getRegionTeethIds(region);
        const treatable = this.getTreatableTeeth(region);
        if (treatable.length === 0) return [];
        if (['crown_implants_one_phase', 'crown', 'crown_implants', 'veneer'].includes(tpl.title)) {
            // use first available toothId
            return [treatable[0]];
            //@todo: modify status
        }
        if (regionToothIds.length === treatable.length) return [];
        if (['bridge','bridge_implants', 'bridge_implants_one_phase'].includes(tpl.title)) {
            let parts = Helper.breakBridgesToParts(treatable);
            // get the longest part
            parts.sort(function(a, b) {
                if (a.length > b.length) return -1;
                if (b.length > a.length) return 1;
                return 0;
            });
            return parts[0];
        }
        return [];
    },

    modifyTemplatePositions(basePositions, tpl, step) {
        const toothId = step.tooth_id;
        if (basePositions.length === 0) return toothId;

        if (['bridge','bridge_implants', 'bridge_implants_one_phase'].includes(tpl.title) && [10, 11, 12, 13].includes(step.state)) {
            return PlanSimpleModifierService.getPillars(basePositions);
        }
        return basePositions;
    },


    getSteps(tpl, region) {
        const steps = this.getStepsForRegion(tpl, region);
        this.tpl = tpl;
        let addedSteps = [];

        if (this.debug) Debug.info("Adding template steps", steps, tpl);

        const basePositions = this.getBaseTemplatePositions(tpl, region);
        // this.addTitleStage(tpl);

        steps.forEach((step) => {
            if (step.tooth_id.length === 0) return;
            if (step.active === false || parseInt(step.active) === 0) return;
            step.tooth_id = this.convertTeethForArea(step.tooth_id, region, tpl.full_jaw);
            step.tooth_id = this.modifyTemplatePositions(basePositions, tpl, step);

            const newSteps = this.getStep(step.state, step.tooth_id, step);
            addedSteps = addedSteps.concat(newSteps);
        });

        this.setProtocolPrices(tpl, addedSteps);

        addedSteps.forEach((step) => {
            step.fullJaw = tpl.full_jaw ? 1 : 0;
            step.tpl = tpl.title;
            step.jaw = app.$store.state.simplePlan.selectedJaw;
            if (typeof step.options !== "undefined") {
                step.options.forEach((option) => {
                    option.fullJaw = tpl.full_jaw ? 1 : 0;
                    option.jaw = app.$store.state.simplePlan.selectedJaw;
                });
            }
        });

        return addedSteps;
    },

    setProtocolPrices(tpl, steps) {
        // Get selected variation

        // if (parseInt(tpl.full_jaw) !== 1) return;
        const pId = parseInt(tpl.variations_by);
        if (isNaN(pId)) return;

        const selectedVariation = 0;
        steps.forEach((step) => {
            if (parseInt(step.state_pid) !== pId || typeof step.options === "undefined") return;
            step.options.forEach((option) => {
                option.isProtocolVariation = 1;
                option.fullJaw = parseInt(tpl.full_jaw);
                if (parseInt(tpl.full_jaw) === 1) {
                    // option.price = app.$store.getters["smart/priceOfVariation"](tpl.title, option.state_id, app.$store.state.currency);
                    // option.unit_price = option.price / option.amount;
                }
            });
        });
    },

    getProtocolVariations(stateId, selection, params) {
        let steps = [];
        if (typeof this.tpl.variation_active === "undefined") return [];
        this.tpl.variation_active.forEach((active, i) => {
            if(!parseInt(active)) return;
            const baseStep = app.$store.getters["smart/treatmentById"](stateId);
            const step = this.getStep([207], selection, params)[0];
            step.title = this.tpl.variation_titles[i][app.$store.state.localSettings.language] || app.$t("plan_calculator.untitled_variation");
            const price = this.tpl.variation_prices[i][app.$store.state.localSettings.currency] || 0;
            step.title_animation = baseStep.title_animation;
            step.state_id = stateId;
            step.state_pid = stateId;
            step.price = parseFloat(price);
            step.unit_price = parseFloat(price) / parseInt(step.amount);
            step.tpl = this.tpl.title;
            step.variation_index = i;
            steps.push(step);
        });
        steps.forEach((step, i) => {
            step.selected = i === 0 ? 1 : 0;
        });
        return steps;
    },

    getStepVariations(stateId, selection, params) {
        const options = this.getTreatmentOptions(stateId);
        if (options.length === 0) return [];
        let steps = [];
        options.forEach((id) => {
            const newSteps = this.getStep([parseInt(id)], selection, params);
            steps = steps.concat(newSteps);
        });
        steps.forEach((step, i) => {
            if (parseInt(stateId) === 315) {
                step.selected = 0;
            } else {
                step.selected = i === 0 ? 1 : 0;
            }
        });
        return steps;
    },

    getStep(stateIds, selection, params) {
        const newSteps = [];
        if (typeof stateIds !== "object") stateIds = [stateIds];

        stateIds.forEach((stateId) => {
            const step = app.$store.getters["smart/treatmentById"](stateId);
            if (step === null) {
                console.error("Missing treatment " + stateId);
                return;
            }
            step.unit_price = app.$store.getters["smart/priceOfTreatment"](stateId, app.$store.state.currency);
            if (typeof params.forced_price !== "undefined") {
                step.unit_price = parseFloat(params.forced_price);
            }
            if (typeof params.editable !== "undefined") {
                step.editable = params.editable;
            }
            if (typeof params.animation_pid !== "undefined") {
                step.animation_pid = params.animation_pid;
            }

            if (typeof params.unselectable !== "undefined") {
                step.unselectable = params.unselectable;
            }

            if (typeof params.ordering !== "undefined") {
                step.ordering = params.ordering;
            } else {
                step.ordering = 0;
            }

            if (typeof params.merge_id !== "undefined") {
                step.merge_id = params.merge_id;
            } else {
                step.merge_id = step.state_pid;
            }
            if (typeof params.primary !== "undefined") {
                step.primary = parseInt(params.primary);
            } else {
                step.primary = 0;
            }

             if (typeof params.disable_options !== "undefined") {
                step.disable_options = params.disable_options;
            } else {
                step.disable_options = 0;
            }

            if (typeof params.update_with !== "undefined") {
                step.update_with = params.update_with;
            } else {
                step.update_with = [];
            }

            if (typeof params.title !== "undefined" && typeof params.title[app.$store.state.language] !== "undefined") {
                step.title_animation = params.title[app.$store.state.language];
            } else if (typeof params.default_title !== "undefined") {
                step.title_animation = params.default_title;
            }
            step.tooth_id = selection.join(",");
            step.amount = step.batch_price ? 1 : selection.length;
            step.price = step.amount * step.unit_price;

            if (step.has_options === 1) {
                let options = [];
                if (this.tpl && this.tpl.full_jaw && [10, 11].includes(parseInt(step.state_pid))) options = this.getProtocolVariations(step.state_id, selection, params);
                else if (this.tpl.title === "preci_vertix" && parseInt(step.state_pid) === 15) options = this.getProtocolVariations(step.state_id, selection, params);
                else if (this.tpl.title === "full_bridge" && parseInt(step.state_pid) === 15) options = this.getProtocolVariations(step.state_id, selection, params);
                else if (this.tpl.title === "full_dentures" && parseInt(step.state_pid) === 300) options = this.getProtocolVariations(step.state_id, selection, params);
                else if (step.animation_pid && step.animation_pid === 10) options = this.getStepVariations(10, selection, params);
                else options = this.getStepVariations(step.state_id, selection, params);
                if (options.length > 0) {
                    step.parent_id = step.id;
                    step.options = options;
                }
            }
            newSteps.push(step);
        });
        return newSteps;
    },

    convertTeethForArea: function(teeth, region, full_jaw) {
        if (typeof(full_jaw)==="undefined") full_jaw = 0;
        else full_jaw = parseInt(full_jaw);
        region = parseInt(region);

        for (const i in teeth) {
            teeth[i] = this.convertToothForArea(teeth[i], region, full_jaw);
        }

        return teeth;
    },

    convertToothForArea: function(tooth_id, region, full_jaw) {
        if (typeof(full_jaw)==="undefined") full_jaw = 0;
        else full_jaw = parseInt(full_jaw);
        region = parseInt(region);
        tooth_id = parseInt(tooth_id);

        if (tooth_id == 0) return tooth_id;

        if (full_jaw) {
            if (region <3 ) return tooth_id;
            else return tooth_id + 20;
        }

        switch (region) {
            case 1:
                return tooth_id + 10;
            case 3:
                return tooth_id + 30;
            case 4:
            case 5:
                return tooth_id + 20;
            default:
                return tooth_id;
        }
    },

    recalcGroupPrice(steps) {
        let total = 0;
        steps.forEach((step) => {
            if (parseInt(step.billable) === 0) return;
            if (typeof step.options !== "undefined") {
                step.options.forEach((option) => {
                    if (option.selected === 1) total += option.price;
                });
            } else total += step.price;
        });
        return total;
    },

    getTeethIds(selectedRegion) {
        const teethIdsUpper = [17, 16, 15, 14, 13, 12, 11, 21, 22, 23, 24, 25, 26, 27];
        const teethIdsLower = [47, 46, 45, 44, 43, 42, 41, 31, 32, 33, 34, 35, 36, 37];
        return (selectedRegion < 3) ? teethIdsUpper : teethIdsLower;
    },

    getJawTotals(groups) {
        let upper = 0;
        let lower = 0;
        groups.forEach((group) => {
            if (group.selectedRegion < 3) upper += parseFloat(group.fullTotal);
            else lower += parseFloat(group.fullTotal);
        });
        return {upper: upper, lower: lower};
    },

    cleanupSteps(tpl, steps, jaw) {
        for (let i = steps.length - 1; i>=0; i--) {
            const step = steps[i];

            if (typeof tpl.full_jaw === "undefined" || parseInt(tpl.full_jaw) === 0) {
                if(step.tooth_id === "") steps.splice(i, 1);
            } else {
                if (parseInt(tpl.full_jaw) === 1 && jaw === step.jaw) steps.splice(i, 1);
                else if (step.fullJaw && jaw === step.jaw) steps.splice(i, 1);
            }
        }
    },


    mergeSteps(origSteps, newSteps, tpl) {
        newSteps.forEach((step) => {
            const origStep = this.getStepByMergeId(step, origSteps);
            if (origStep === null || step.fullJaw) {
                origSteps.push(step);
            } else {
                this.mergeStepWithOriginal(origStep, step);
            }
        });
    },

    mergeStepWithOriginal(origStep, step) {
        const origIds = origStep.tooth_id.split(",");
        const newIds = step.tooth_id.split(",");
        const ids = Helper.sortToothNumbers(origIds.concat(newIds));
        origStep.update_with.push(...step.update_with);
        origStep.tooth_id = ids.join(",");
        origStep.amount = parseInt(origStep.batch_price) === 1 ? 1 : ids.length;
        origStep.price = origStep.amount * parseFloat(origStep.unit_price);
        if (typeof origStep.options !== "undefined") {
            origStep.options.forEach((opt)=>{
                opt.tooth_id = origStep.tooth_id;
                opt.amount = origStep.amount;
                opt.price = origStep.amount * parseFloat(opt.unit_price);
            });
        }
    },

    getStepByMergeId(newStep, steps) {
        const id = String(newStep.merge_id);
        const jaw = newStep.jaw;
        const ordering = newStep.ordering;
        for (const i in steps) {
            if (String(steps[i].merge_id) === id && jaw === steps[i].jaw && steps[i].ordering === ordering) return steps[i];
        }
        return null;
    },

    getStepByPid(pid, jaw, steps) {
        pid = parseInt(pid);
        for (const i in steps) {
            if (parseInt(steps[i].state_pid) === pid && jaw === steps[i].jaw) return steps[i];
        }
        return null;
    },

    getJawRange(jaw) {
        const steps = app.$store.state.simplePlan.steps;
        let toothIds = [];
        steps.forEach((step) => {
            if (step.jaw !== jaw) return;
            toothIds = toothIds.concat(step.tooth_id.split(","));
        });
        toothIds.forEach((id, i) => {
            toothIds[i] = parseInt(id);
        });
        toothIds = Helper.sortToothNumbers(toothIds);
        return ([toothIds[0], toothIds[toothIds.length-1]]);
    },

    getPrimaryStepsForJaw(jaw) {
            const primarySteps = [];
            const stateIds = [];
            const steps = app.$store.state.simplePlan.steps;

            //const ids = app.$store.state.simplePlan.primaryTreatments;

            steps.forEach((step) => {
                if (step.jaw !== jaw) return;
                if (!step.primary) return;

                if ([320].includes(step.state_id)) return;

                primarySteps.push(step);
                stateIds.push(parseInt(step.state_pid));
            });

            const filteredIds = stateIds.filter((item, i) => {
                return stateIds.indexOf(item) === i;
            });

            // 15 9 26 300 11 10
            const filteredIdsOrdered = [];
            [26, 9, 15, 300, 11, 10].forEach((id) => {
                const idx =  filteredIds.indexOf(id);
                if (idx >= 0) {
                    filteredIdsOrdered.push(id);
                    filteredIds.splice(idx, 1);
                }
            });
            filteredIds.forEach((id)=>{
                filteredIdsOrdered.push(id);
            });

            return ({
                stateIds: filteredIdsOrdered,
                steps: primarySteps,
            });

             /*   if (this.selectedRegion > 2) {
                    if (!Helper.isStepInRegion(step, 3) && !Helper.isStepInRegion(step, 4) && !Helper.isStepInRegion(step, 5)) return;
                    this.affectedSteps.push(step);
                    if(step.primary) found.push(parseInt(step.state_pid));
                    //if (ids.includes(parseInt(step.state_pid))) found.push(parseInt(step.state_pid));
                } else {
                    if (!Helper.isStepInRegion(step, 0) && !Helper.isStepInRegion(step, 1) && !Helper.isStepInRegion(step, 2)) return;
                    this.affectedSteps.push(step);
                    //if (ids.includes(parseInt(step.state_pid))) found.push(parseInt(step.state_pid));
                    if(step.primary) found.push(parseInt(step.state_pid));
                }
            });
            return found.filter((item, i) => {
                return found.indexOf(item) === i;
            });*/
        },
};
